import React from "react";
import { BRANDS } from "@/data/site";
import { Reveal } from "@/components/Reveal";

export default function BrandsStrip() {
  return (
    <section className="bg-white py-16 border-y border-slate-100" data-testid="brands">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <Reveal>
          <p className="text-center text-slate-500 text-sm mb-8">We select the most suitable high-quality systems from trusted manufacturers</p>
        </Reveal>
        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-6 items-center">
          {BRANDS.map((b, i) => (
            <Reveal key={b} delay={i * 0.04}>
              <div className="flex items-center justify-center h-14 grayscale opacity-50 hover:grayscale-0 hover:opacity-100 transition-all duration-500">
                <span className="font-display font-extrabold text-lg text-navy-deep text-center">{b}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
